@if(staticOffersWall?.active){
<section class="static-offers">
    @if(staticOffersWall?.heading){
    <h2 [innerHTML]="staticOffersWall?.heading"></h2>
    }
    <div id="scroll-box" class="logo-container"
        [ngClass]="isMobile ? 'logo-container-mobile' : 'logo-container-desktop'" (scroll)="scrollHandler($event)">
        @for(tile of staticOffersWall?.offerTiles; track tile; let index = $index){
        <a [id]="'tiles_' + index" href="javascript:void(0)" (click)="openModal($event, tile?.link)"
            [attr.aria-label]="tile?.title || 'Merchant website'">
            <div>
                <img [ngSrc]="csp.imagePrefix() + tile?.logo?.src" [alt]="tile?.logo?.altText" width="132" height="102">
                <div class="line" aria-hidden="true"></div>
                <p>
                    <span [innerHTML]="tile?.title | safeHtml" aria-hidden="true"></span>
                    <img class="right-arrow" [ngSrc]="csp.imagePrefix() + staticOffersWall?.arrow?.src"
                        [alt]="staticOffersWall?.arrow?.altText" width="20" height="20">
                </p>
            </div>
        </a>
        }
    </div>
    @if(staticOffersWall?.footerNote){
    <p [innerHTML]="staticOffersWall?.footerNote | safeHtml"></p>
    }
    @if(isMobile){
    <div class="row circle-wrap text-center">
        <ul id="card-bullets" class="bullets" aria-hidden="true">
            <li style="text-decoration: none; list-style: none; display: inline-block;"
                *ngFor="let item of circlesArray;let i = index;" (click)="focusCard(item)" tabindex="0"
                (keypress)="focusCard(item)">
                <span class="sr-only">Offer wall {{i + 1}} out of 3</span>
                <svg class="card-bullet" width="16px" height="8px" viewBox="0 0 14 14" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <defs></defs>
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g class="card-marker-{{item}}" transform="translate(-149.000000, -2029.000000)" fill="#E8E8E8"
                            [attr.aria-selected]="item === selectedItem">
                            <g transform="translate(149.000000, 2029.000000)">
                                @if(item === selectedItem){
                                <rect x="4" y="0" width="8" height="12" />
                                <path d="M 4 0 A 4 4 0 0 0 4 12" />
                                <path d="M 12 0 A 4 4 0 0 1 12 12" />
                                } @else {
                                <circle cx="7" cy="7" r="7" [attr.aria-selected]="item === selectedItem"></circle>
                                }
                            </g>
                        </g>
                    </g>
                </svg>
            </li>
        </ul>
    </div>
    }
</section>
}